import React from 'react'
import { CommandItem } from 'cmdk'
import { Box } from 'rebass/styled-components'

export interface SmartSelectLoadMoreProps {
  children: React.ReactNode
  onSelect: () => void
}

export const SmartSelectLoadMore = ({ children, onSelect }: SmartSelectLoadMoreProps): JSX.Element => {
  return (
    // CommandItem is used here to ensure the item is accessible via keyboard navigation
    <CommandItem key="load-more" value="load-more" onSelect={onSelect}>
      <Box data-name="button-tertiary" variant="buttons.tertiary">
        {children}
      </Box>
    </CommandItem>
  )
}
